export const INIT_DATA_PAGINATOR = {
    currentPage: 1,
    quantityPages: 0,
    totalRecords: 0
};